
import KlassService from "@/api/klassService";
import teacherStore from "./teacher";
const state = {
	klassList: [],
};

const getters = {
	klassList: state => state.klassList,
};

const actions = {
	getKlassListService({ commit }, data) {
		const isManager = teacherStore.getters.isManager(teacherStore.state);
		const teacherInfo = teacherStore.state.teacherInfo;
		return new Promise((resolve, reject) => {
			if ((!data || !data.isForce) && !!state.klassList.length) {
				resolve(state.klassList);
				return;
			}
			const params = {};
			if (isManager) {
				params.school_id = teacherInfo.school_id;
			} else {
				const teachers = teacherInfo.teachers || [];
				params.klass_ids = teachers.filter(item => item.is_active && item.klass).map(item => item.klass.id).join(",");
			}

			KlassService.getKlassListService(params).then((res) => {
				commit("klassList", res);
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
		});
	},
};

const mutations = {
	klassList(state, klassList) {
		state.klassList = klassList;
	},
};

export default {
	actions,
	getters,
	state,
	mutations,
};
